import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/payroll/periods/$periodId',
}).lazy(() => import('./periods.$periodId.index.lazy').then((d) => d.Route))
